import { render, staticRenderFns } from "./ListWinners.vue?vue&type=template&id=0d72aafd&scoped=true&"
import script from "./ListWinners.vue?vue&type=script&lang=js&"
export * from "./ListWinners.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/draws.scss?vue&type=style&index=0&id=0d72aafd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d72aafd",
  null
  
)

export default component.exports